import { IconButton } from "$components/button/icon-button";
import { Card } from "$components/card";
import { CloseIcon } from "$components/icons";
import { ProductOriginBadge } from "$routes/inventory/_lib/product-origin-badge";
import { RHFTextField } from "$routes/inventory/_lib/rhf-text-field";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import dayjs from "dayjs";
import { FormattedMessage, useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  titleRow: {
    marginBottom: theme.spacing(2),
  },
  grayText: {
    color: theme.palette.grey[700],
    minWidth: 65,
    marginBottom: theme.spacing(1),
  },
}));

type Props = {
  lotId: string;
  quantityInputName: string;
  locationName: string;
  expiryDate: string;
  lotName: string;
  currentLotQuantity: number;
  locationError?: string;
  onRemoveClick: () => void;
  externalReferences?: ReadonlyArray<{ origin: string }>;
};

export function MoveLotCard({
  lotId,
  quantityInputName,
  lotName,
  locationName,
  expiryDate,
  currentLotQuantity,
  locationError,
  onRemoveClick,
  externalReferences,
}: Props) {
  const classes = useStyles();

  const { formatMessage } = useIntl();
  return (
    <Card data-testid={`move-lot-card-${lotId}`}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className={classes.titleRow}
      >
        <Box display="flex" alignItems="center" gridGap={8}>
          <Typography>{lotName}</Typography>
          <ProductOriginBadge externalReferences={externalReferences} />
        </Box>
        <IconButton aria-label="remove item" onClick={onRemoveClick}>
          <CloseIcon style={{ fontSize: "1rem" }} />
        </IconButton>
      </Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={7}>
            <Box display="flex">
              <Typography variant="body2" className={classes.grayText}>
                <FormattedMessage
                  id="inventory.move.lotCard.quantity"
                  defaultMessage="Location"
                />
              </Typography>
              <Typography variant="body2">{locationName}</Typography>
            </Box>
            <Box display="flex">
              <Typography variant="body2" className={classes.grayText}>
                <FormattedMessage
                  id="inventory.move.lotCard.expiry"
                  defaultMessage="Expiry"
                />
              </Typography>
              <Typography variant="body2">
                {dayjs(expiryDate, "YYYY-MM-DD").format("MM / YYYY")}
              </Typography>
            </Box>
            <Box display="flex">
              <Typography variant="body2" className={classes.grayText}>
                <FormattedMessage
                  id="inventory.move.lotCard.currentQuantity"
                  defaultMessage="Qty"
                />
              </Typography>
              <Typography variant="body2">{currentLotQuantity}</Typography>
            </Box>
          </Grid>
          <Grid item xs={5}>
            <RHFTextField
              label={formatMessage({
                id: "inventory.move.lotCard.quantityToMove.label",
                defaultMessage: "Qty to Move",
              })}
              name={quantityInputName}
              type="number"
            />
          </Grid>
        </Grid>
      </Box>
      <Typography variant="caption" color="error">
        {locationError}
      </Typography>
    </Card>
  );
}
